<template>
  <div>
    <div class="legend-box" :style="{backgroundColor: color}"></div>
    <div class="legend-text">{{name}}</div>
  </div>
</template>

<script>
export default {
  name: 'LegendEntry',
  props: {
    name: {
      type: String
    },
    color: {
      type: String
    }
  }
};
</script>

<style scoped lang="scss">
  @import "../style/color_";

  .legend-text {
    display: inline-block;
    color: $color-secondary;
  }

  .legend-box {
    width: 11px;
    height: 11px;
    margin: -2px 8px;
    display: inline-block;
  }

</style>
